// extracted by mini-css-extract-plugin
export var artArchiveStyle = "FeaturedMediaImage-module--art-archive-style--5DUgS";
export var defaultStyle = "FeaturedMediaImage-module--default-style--Erk6o";
export var featuredMediaImage = "FeaturedMediaImage-module--featured-media-image--7YWKV";
export var homeStyle = "FeaturedMediaImage-module--home-style--PmLom";
export var image = "FeaturedMediaImage-module--image--DCKIi";